import { combineReducers } from 'redux'
import User from '@engine/user'
import Comps from '@engine/comps'
import Property from '@engine/property'

export default combineReducers({
  [User.namespace]: User.reducer,
  [Comps.namespace]: Comps.reducer,
  [Property.namespace]: Property.reducer
})
